/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Samlla
 * Samlla Backend API
 * OpenAPI spec version: 0.1.0
 */
import { createMutation, createQuery } from '@tanstack/svelte-query';
import type {
	CreateMutationOptions,
	CreateMutationResult,
	CreateQueryOptions,
	CreateQueryResult,
	DataTag,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey
} from '@tanstack/svelte-query';

import type {
	FavoriteOperationResponse,
	FavoritesList,
	FavoritesReorderRequest,
	FavoritesReorderResponse,
	HTTPValidationError
} from '.././schemas';

import { customInstance } from '../../orval/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Get user's favorites list with mixed categories and trackers.
 * @summary Get Favorites
 */
export const getFavoritesApiFavoritesGet = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<FavoritesList>({ url: `/api/favorites`, method: 'GET', signal }, options);
};

export const getGetFavoritesApiFavoritesGetQueryKey = () => {
	return [`/api/favorites`] as const;
};

export const getGetFavoritesApiFavoritesGetQueryOptions = <
	TData = Awaited<ReturnType<typeof getFavoritesApiFavoritesGet>>,
	TError = unknown
>(options?: {
	query?: Partial<
		CreateQueryOptions<Awaited<ReturnType<typeof getFavoritesApiFavoritesGet>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetFavoritesApiFavoritesGetQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getFavoritesApiFavoritesGet>>> = ({
		signal
	}) => getFavoritesApiFavoritesGet(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof getFavoritesApiFavoritesGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFavoritesApiFavoritesGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getFavoritesApiFavoritesGet>>
>;
export type GetFavoritesApiFavoritesGetQueryError = unknown;

/**
 * @summary Get Favorites
 */

export function createGetFavoritesApiFavoritesGet<
	TData = Awaited<ReturnType<typeof getFavoritesApiFavoritesGet>>,
	TError = unknown
>(
	options?: {
		query?: Partial<
			CreateQueryOptions<Awaited<ReturnType<typeof getFavoritesApiFavoritesGet>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetFavoritesApiFavoritesGetQueryOptions(options);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Add item (category or tracker) to favorites.
 * @summary Add To Favorites
 */
export const addToFavoritesApiFavoritesItemTypeItemIdPost = (
	itemType: 'category' | 'tracker',
	itemId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<FavoriteOperationResponse>(
		{ url: `/api/favorites/${itemType}/${itemId}`, method: 'POST', signal },
		options
	);
};

export const getAddToFavoritesApiFavoritesItemTypeItemIdPostMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof addToFavoritesApiFavoritesItemTypeItemIdPost>>,
		TError,
		{ itemType: 'category' | 'tracker'; itemId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof addToFavoritesApiFavoritesItemTypeItemIdPost>>,
	TError,
	{ itemType: 'category' | 'tracker'; itemId: string },
	TContext
> => {
	const mutationKey = ['addToFavoritesApiFavoritesItemTypeItemIdPost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof addToFavoritesApiFavoritesItemTypeItemIdPost>>,
		{ itemType: 'category' | 'tracker'; itemId: string }
	> = (props) => {
		const { itemType, itemId } = props ?? {};

		return addToFavoritesApiFavoritesItemTypeItemIdPost(itemType, itemId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type AddToFavoritesApiFavoritesItemTypeItemIdPostMutationResult = NonNullable<
	Awaited<ReturnType<typeof addToFavoritesApiFavoritesItemTypeItemIdPost>>
>;

export type AddToFavoritesApiFavoritesItemTypeItemIdPostMutationError = HTTPValidationError;

/**
 * @summary Add To Favorites
 */
export const createAddToFavoritesApiFavoritesItemTypeItemIdPost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof addToFavoritesApiFavoritesItemTypeItemIdPost>>,
			TError,
			{ itemType: 'category' | 'tracker'; itemId: string },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof addToFavoritesApiFavoritesItemTypeItemIdPost>>,
	TError,
	{ itemType: 'category' | 'tracker'; itemId: string },
	TContext
> => {
	const mutationOptions = getAddToFavoritesApiFavoritesItemTypeItemIdPostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Remove item (category or tracker) from favorites.
 * @summary Remove From Favorites
 */
export const removeFromFavoritesApiFavoritesItemTypeItemIdDelete = (
	itemType: 'category' | 'tracker',
	itemId: string,
	options?: SecondParameter<typeof customInstance>
) => {
	return customInstance<FavoriteOperationResponse>(
		{ url: `/api/favorites/${itemType}/${itemId}`, method: 'DELETE' },
		options
	);
};

export const getRemoveFromFavoritesApiFavoritesItemTypeItemIdDeleteMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof removeFromFavoritesApiFavoritesItemTypeItemIdDelete>>,
		TError,
		{ itemType: 'category' | 'tracker'; itemId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof removeFromFavoritesApiFavoritesItemTypeItemIdDelete>>,
	TError,
	{ itemType: 'category' | 'tracker'; itemId: string },
	TContext
> => {
	const mutationKey = ['removeFromFavoritesApiFavoritesItemTypeItemIdDelete'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof removeFromFavoritesApiFavoritesItemTypeItemIdDelete>>,
		{ itemType: 'category' | 'tracker'; itemId: string }
	> = (props) => {
		const { itemType, itemId } = props ?? {};

		return removeFromFavoritesApiFavoritesItemTypeItemIdDelete(itemType, itemId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type RemoveFromFavoritesApiFavoritesItemTypeItemIdDeleteMutationResult = NonNullable<
	Awaited<ReturnType<typeof removeFromFavoritesApiFavoritesItemTypeItemIdDelete>>
>;

export type RemoveFromFavoritesApiFavoritesItemTypeItemIdDeleteMutationError = HTTPValidationError;

/**
 * @summary Remove From Favorites
 */
export const createRemoveFromFavoritesApiFavoritesItemTypeItemIdDelete = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof removeFromFavoritesApiFavoritesItemTypeItemIdDelete>>,
			TError,
			{ itemType: 'category' | 'tracker'; itemId: string },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof removeFromFavoritesApiFavoritesItemTypeItemIdDelete>>,
	TError,
	{ itemType: 'category' | 'tracker'; itemId: string },
	TContext
> => {
	const mutationOptions =
		getRemoveFromFavoritesApiFavoritesItemTypeItemIdDeleteMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Reorder favorites according to provided list.
 * @summary Reorder Favorites
 */
export const reorderFavoritesApiFavoritesReorderPut = (
	favoritesReorderRequest: FavoritesReorderRequest,
	options?: SecondParameter<typeof customInstance>
) => {
	return customInstance<FavoritesReorderResponse>(
		{
			url: `/api/favorites/reorder`,
			method: 'PUT',
			headers: { 'Content-Type': 'application/json' },
			data: favoritesReorderRequest
		},
		options
	);
};

export const getReorderFavoritesApiFavoritesReorderPutMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof reorderFavoritesApiFavoritesReorderPut>>,
		TError,
		{ data: FavoritesReorderRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof reorderFavoritesApiFavoritesReorderPut>>,
	TError,
	{ data: FavoritesReorderRequest },
	TContext
> => {
	const mutationKey = ['reorderFavoritesApiFavoritesReorderPut'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof reorderFavoritesApiFavoritesReorderPut>>,
		{ data: FavoritesReorderRequest }
	> = (props) => {
		const { data } = props ?? {};

		return reorderFavoritesApiFavoritesReorderPut(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ReorderFavoritesApiFavoritesReorderPutMutationResult = NonNullable<
	Awaited<ReturnType<typeof reorderFavoritesApiFavoritesReorderPut>>
>;
export type ReorderFavoritesApiFavoritesReorderPutMutationBody = FavoritesReorderRequest;
export type ReorderFavoritesApiFavoritesReorderPutMutationError = HTTPValidationError;

/**
 * @summary Reorder Favorites
 */
export const createReorderFavoritesApiFavoritesReorderPut = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof reorderFavoritesApiFavoritesReorderPut>>,
			TError,
			{ data: FavoritesReorderRequest },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof reorderFavoritesApiFavoritesReorderPut>>,
	TError,
	{ data: FavoritesReorderRequest },
	TContext
> => {
	const mutationOptions = getReorderFavoritesApiFavoritesReorderPutMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
